import type { Faq } from '../types/content'

export const faqs: Faq[] = [
  {
    question: 'What’s the typical deployment process?',
    answer:
      'Discovery, then system design and options, then a proposal and documentation pack, then deployment and commissioning, then ongoing support. For the All-in-One Power System, initial setup takes 3–4 hours and about 30 minutes after that.',
  },
  {
    question: 'What information do you need for a proposal?',
    answer:
      'Your site location and access, a load profile (or power bills and fuel records), any existing generation, your goal (diesel displacement, backup or grid support) and your timeframe. If you don’t have all of it, we’ll work it out with you during discovery.',
  },
  {
    question: 'Can this reduce diesel reliance?',
    answer:
      'Yes, that’s one of the main reasons customers use it. Solar and storage carry the load when conditions allow, so generators run less. How much less depends on your load, location and configuration, and the site assessment works that out before you commit.',
  },
  {
    question: 'Can I see a system before committing?',
    answer:
      'Yes. Book a demo tour at our base in Bibra Lake, Perth, and see the system and how it’s operated in person.',
  },
  {
    question: 'How do support and maintenance work?',
    answer:
      'Support is part of every deployment, from commissioning onwards. Your proposal sets out exactly how support and maintenance will work for your system and location.',
  },
  {
    question: 'Is it complicated to run?',
    answer:
      'No. Once the initial setup is done, the system is plug-and-play. During commissioning we take your team through day-to-day operation.',
  },
  {
    question: 'Do you offer purchase, hire or lease?',
    answer:
      'It depends on the project. Tell us what you need and your proposal will set out the commercial options that fit.',
  },
  {
    question: 'Do you work Australia-wide?',
    answer:
      'Yes. We’re based in Bibra Lake, Perth, and deploy anywhere in Australia. Our systems have been tested in remote areas.',
  },
]
